/** Local cached logos served by the backend (`/logos/{domain}`). */

export function normalizeDomain(domain: string): string {
  let clean = (domain || "").trim().toLowerCase();
  clean = clean.replace(/^https?:\/\//, "");
  clean = clean.split("/")[0].split("?")[0].replace(/^\.+|\.+$/g, "");
  if (clean.startsWith("www.")) clean = clean.slice(4);
  return clean;
}

/** App-relative URL for a cached company logo. */
export function cachedLogoUrl(domain: string): string | null {
  const clean = normalizeDomain(domain);
  if (!clean) return null;
  return `/logos/${encodeURIComponent(clean)}`;
}

/** Two-letter initials from a company name. */
export function companyInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) {
    const word = parts[0].replace(/[^a-zA-Z0-9]/g, "");
    return (word.slice(0, 2) || "?").toUpperCase();
  }
  const a = parts[0].replace(/[^a-zA-Z0-9]/g, "")[0] || "";
  const b = parts[1].replace(/[^a-zA-Z0-9]/g, "")[0] || "";
  return ((a + b) || "?").toUpperCase();
}

/** Deterministic background from company name. */
export function colorFromCompany(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue} 42% 38%)`;
}
